<script lang="ts">
	import { onMount } from "svelte";

	import Introduction from "./Introduction.svelte";
	import InspirationAndBackground from "./InspirationAndBackground.svelte";
	import Instructions from "./Instructions.svelte";
	import Pwt from "./Pwt.svelte";
	import StatsWeb from "./StatsWeb.svelte";
	import Canes from "./Canes.svelte";
	import Layout from "./Layout.svelte";
	import About from "./About.svelte";
	import { getCanvasMaxSize } from '../../common/helpers.js';

	import GeneratePieceOfArt from "../../common/GeneratePieceOfArt.svelte";

	export let pwtData: any;
	export let stats: any;
	export let hash: string;

	let width: number;
	onMount(async () => {
		width = getCanvasMaxSize("#artSection");
	});
</script>

<main class="container">
	<section>
		<Introduction />
	</section>

	<section>
		<InspirationAndBackground />
	</section>

	<section id="artSection">
		<h1>A random final paperweight</h1>
		<Pwt {pwtData} {width} height={width} />
		<Instructions />
	</section>

	<GeneratePieceOfArt {hash}/>

	<section>
		<h1>List of canes</h1>
		<p>
			The paperweight is composed of numerous <i>canes</i>. Each cane has
			properties, and is present a specific number of times in the paperweight.
		</p>
		<Canes centers={pwtData.centers} {stats} />
	</section>

	<section>
		<h1>Layout explained</h1>
		<Layout {pwtData} layoutType={stats.layoutType} size={300} />
	</section>

	<section>
		<h1>Stats explained</h1>
		<StatsWeb {stats} />
	</section>

	<section>
		<h1>About Murano Fantasy and Pandelune</h1>
		<div><About /></div>
	</section>

	<footer>
		<span id="copyright"
			>&copy; Copyright 2022, Pandelune. All the content is under copyright,
			including the source code of "Murano Fantasy".</span
		>
	</footer>
</main>
